/**
 * Distribution chart color palettes
 *
 * Standard order: GOOD to BAD (Green → Red)
 * After series.reverse(), charts display: BAD at bottom, GOOD at top
 */

// Base 5-color scale (most common - for 5-point drivers and workflows)
export const DISTRIBUTION_COLORS_5 = [
  "#bbf7d0", // tailwind green-200 - GOOD (Always, Very Satisfied, etc.)
  "#d9f99d", // tailwind lime-200
  "#fef08a", // tailwind yellow-200 - NEUTRAL
  "#fed7aa", // tailwind orange-200
  "#fecaca", // tailwind red-200 - BAD (Never, Very Dissatisfied, etc.)
];

// Extended 6-color scale (for CSAT, Delivery with "worst" option, and workflows)
export const DISTRIBUTION_COLORS_6 = [
  ...DISTRIBUTION_COLORS_5,
  "#fbcfe8", // tailwind pink-200 - WORST (Very Dissatisfied + 1)
];

// 3-color scale (3-point drivers)
export const DISTRIBUTION_COLORS_3 = [
  DISTRIBUTION_COLORS_5[0], // Green - GOOD
  DISTRIBUTION_COLORS_5[2], // Yellow - NEUTRAL
  DISTRIBUTION_COLORS_5[3], // Orange - BAD
];

// Binary scale (Yes/No workflows)
export const DISTRIBUTION_COLORS_BINARY = [
  DISTRIBUTION_COLORS_5[0], // Green - "Yes" (GOOD)
  DISTRIBUTION_COLORS_5[2], // Yellow - "No" (BAD)
];

/**
 * Get appropriate color array based on number of options
 * @param {number} count - Number of options/scale points
 * @returns {Array<string>} Appropriate color array
 */
export function getDistributionColors(count) {
  switch (count) {
    case 2:
      return DISTRIBUTION_COLORS_BINARY;
    case 3:
      return DISTRIBUTION_COLORS_3;
    case 5:
      return DISTRIBUTION_COLORS_5;
    case 6:
      return DISTRIBUTION_COLORS_6;
    default:
      return DISTRIBUTION_COLORS_5;
  }
}
